import { render } from "./CountTo.vue?vue&type=template&id=3d5821a1"
import script from "./CountTo.vue?vue&type=script&lang=js"
export * from "./CountTo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__